import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { toast } from 'react-toastify';
import SweetAlert from 'react-bootstrap-sweetalert';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import Button from 'components/CustomButtons/Button';
import { remove } from 'helpers/apiHelpers';
import { isGranted } from 'helpers/helpers';
import { ROLE_REMOVE_DISH_CATEGORY } from 'helpers/roles';

const DeleteCategoryAction = ({ row, grid, t, classes }) => {
  const [alert, setAlert] = useState(null);

  if (!isGranted(ROLE_REMOVE_DISH_CATEGORY)) {
    return null;
  }

  const closeAlert = () => setAlert(null);

  const handleClick = () => {
    if (row.dishesCount > 0) {
      toast.error(t('dishCategories.delete.hasDishes'));
      return;
    }

    setAlert(
      <SweetAlert
        warning={true}
        title={t('dishCategories.delete.confirmTitle', { name: row.name })}
        onConfirm={async () => {
          try {
            await remove(row['@id']);
            grid.current.fireFetchData();
            toast.success(t('dishCategories.delete.success'));
          } catch (error) {
            toast.error(
              error?.response?.data?.['hydra:description'] ??
                t('form.somethingWentWrong')
            );
          }
          closeAlert();
        }}
        onCancel={closeAlert}
        confirmBtnCssClass={`${classes.button} ${classes.danger}`}
        cancelBtnCssClass={classes.button}
        confirmBtnText={t('dishCategories.delete.confirmButton')}
        cancelBtnText={t('common.shared.cancel')}
        showCancel={true}
      />
    );
  };

  return (
    <React.Fragment>
      {ReactDOM.createPortal(alert, document.getElementById('portal'))}
      <Button
        justIcon={true}
        round={true}
        simple={true}
        onClick={handleClick}
        color="danger"
        className="remove"
        style={{ margin: '10px 5px', padding: '0', width: '20px' }}
      >
        <DeleteForeverIcon />
      </Button>
    </React.Fragment>
  );
};

export default DeleteCategoryAction;
